AFRAME.registerComponent('menu', {
    multiple: true,
    schema: {
        zpos: {type: 'number', default: -2},
        xoffset: {type: 'number', default: 0},
        yoffset: {type: 'number', default: 0},
        show: {type: 'boolean', default: false}
    },
    init: function () {
        var data = this.data;
        var el = this.el; 
        var sceneEl = document.querySelector('a-scene');
        var cam = sceneEl.querySelector('#camera');
        this.cameraEl = cam;
        if(this.cameraEl){
            this.initHeight =  Math.round(this.cameraEl.object3D.getWorldPosition().y * 100) / 100;
            this.yaxis = new THREE.Vector3(0, 1, 0);
            this.zaxis = new THREE.Vector3(0, 0, 1);
            this.pivot = new THREE.Object3D();
            this.el.object3D.position.set(this.data.xoffset, this.initHeight + this.data.yoffset, this.data.zpos);
            this.el.sceneEl.object3D.add(this.pivot);
            this.pivot.add(this.el.object3D);           
        }else{
            console.log("Please add a camera to your scene.");
        }
    },
    place: function() {
    	console.log(" ---------- place called");

        var direction = this.zaxis.clone();
        direction.applyQuaternion(this.cameraEl.object3D.quaternion);
        var ycomponent = this.yaxis.clone().multiplyScalar(direction.dot(this.yaxis));
        direction.sub(ycomponent);
        direction.normalize();
        this.pivot.quaternion.setFromUnitVectors(this.zaxis, direction);
        var xposition = this.cameraEl.object3D.getWorldPosition().x;
        var yposition = (Math.round(this.cameraEl.object3D.getWorldPosition().y * 100) / 100);
        var zposition = this.cameraEl.object3D.getWorldPosition().z;
        if(this.initHeight === yposition && this.initHeight !== 0){
            yposition = 0
        }else{
            yposition = yposition - this.initHeight;
        }
        this.pivot.position.set(xposition, yposition, zposition);
    },  
    update: function (oldData) {
        var data = this.data;
        var el = this.el; 
        if(data.show){
            this.place();
  
            this.el.removeAttribute('animation__invisible');
            this.el.removeAttribute('animation__out');
  
            this.el.setAttribute('visible', true);
            this.el.setAttribute('scale', '0.00001 0.00001 0.00001');
            this.el.setAttribute('animation__enter', `property: scale; from: 0.00001 0.00001 0.00001; to:1 1 1; dur:1000; delay:350; easing: easeOutElastic;`);
        }else{
            this.el.removeAttribute('animation__enter');
            
            this.el.setAttribute('animation__out', `property: scale; to: 0.00001 0.00001 0.00001; from:1 1 1; dur:1000; delay:350; easing: easeOutElastic;`);
            this.el.setAttribute('animation__invisible', `property: visible; from: true; to:false; delay:350;`);
        }
    }
  });



AFRAME.registerComponent('menutrigger', {
    schema: {
        angle: {type: 'number', default: 30}
    },
    init: function () {
         // var yDisplay = document.createElement("a-entity");
         // yDisplay.setAttribute('geometry', 'primitive: plane; width: 0.5; height: 0.2;');
         // yDisplay.setAttribute('material', 'shader: flat; opacity: 0.2; color: #000000');
         // yDisplay.setAttribute('rotation', '0 0 0');
         // yDisplay.setAttribute('position', '0 0.125 -2');
         // yDisplay.setAttribute('text', 'value', 'y-pos');
         // yDisplay.setAttribute('text', 'align', 'center');
         // yDisplay.setAttribute('text', 'wrapCount', '10');
         // this.el.appendChild(yDisplay);
         // this.yDisplay = yDisplay;
    },
    tick: function () {

        var rotation = this.el.object3D.getWorldQuaternion(this.rotation);
        var angle = Math.round(THREE.Math.radToDeg(rotation.x) * 100) / 100;
 //       this.yDisplay.setAttribute('text', 'value', angle);
        if(angle > this.data.angle){
 //         this.yDisplay.setAttribute('material', 'shader: flat; opacity: 0.2; color: red');
          document.querySelector('a-entity[menu]').setAttribute('menu','show',true);
        }else{
 //         this.yDisplay.setAttribute('material', 'shader: flat; opacity: 0.2; color: #000000'); 
          document.querySelector('a-entity[menu]').setAttribute('menu','show',false);           
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/menu.js
// module id = 8
// module chunks = 0